import vue from 'vue';
import toastComponent from './index.vue';
import Vue from 'vue';

const ToatConatructor = vue.extend(toastComponent);

function showToast({
  text,
  duration = 1500,
  error = 0,
  container = 'body',
  left = '50%',
  right = 'auto',
  top = 'auto',
  bottom = '10%',
  type = 1,
  width = 'auto',
  assist = '',
  fontSize = '12px',
  custom = ''
} = {}) {
  // 实例化
  const toastDom = new ToatConatructor({
    el: document.createElement('div'),
    data() {
      return {
        show: true,
        text,
        error,
        left,
        bottom,
        right,
        top,
        width,
        type,
        assist,
        fontSize
      };
    },
    mounted() {
      // 自定义模板
      if (custom) {
        let hvue = Vue.extend(custom);
        // 挂载模板
        let components = new hvue().$mount().$el;
        this.$nextTick(() => {
          document.getElementById('toast-template').appendChild(components);
        })
      }
    }
  });

  // 插入节点
  createDom(container, toastDom)

  // 过了duration后消失
  setTimeout(() => {
    toastDom.show = false;
    // 优化，销毁节点
    deleteDom(container, toastDom);
  }, duration);
}

/**
 * 创建节点
 * @param {*} container 支持传入父容器class、id以及节点
 * @param {*} toastDom 需要插入的节点
 */
function createDom(container, toastDom) {
  // console.warn(container, toastDom, toastDom.$el, document.querySelector(container));
  if (typeof container == 'string') {
    document.querySelector(container).appendChild(toastDom.$el);
  } else {
    container.appendChild(toastDom.$el);
  }
}

/**
 * 销毁节点
 * @param {*} container 
 * @param {*} toastDom 
 */
function deleteDom(container, toastDom) {
  if (typeof container == 'string') {
    document.querySelector(container).removeChild(toastDom.$el);
  } else {
    container.removeChild(toastDom.$el);
  }
}

/**
 * 全局挂载节点
 */
function registryToast() {
  vue.prototype.$toast = showToast;
}

export default registryToast;